var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4937 1.3025C15.4921 1.2425 15.4746 1.18583 15.4587 1.12833C15.4462 1.08 15.4404 1.03083 15.4196 0.986667C15.4004 0.943333 15.3679 0.908333 15.3396 0.868333C15.3046 0.8175 15.2729 0.766667 15.2279 0.725C15.2204 0.7175 15.2171 0.7075 15.2087 0.700833C15.1787 0.675 15.1421 0.665833 15.1096 0.645C15.0596 0.6125 15.0104 0.579167 14.9537 0.5575C14.8979 0.5375 14.8429 0.5325 14.7854 0.524167C14.7454 0.518333 14.7096 0.5 14.6671 0.5H10.5004C10.0396 0.5 9.66708 0.873333 9.66708 1.33333C9.66708 1.79333 10.0396 2.16667 10.5004 2.16667H12.8554L9.49208 6.09L5.92875 3.9525C5.57625 3.73917 5.12291 3.8175 4.85958 4.13333L0.692913 9.13333C0.398746 9.48667 0.446246 10.0125 0.79958 10.3067C0.956246 10.4367 1.14458 10.5 1.33291 10.5C1.57208 10.5 1.80875 10.3983 1.97375 10.2L5.68375 5.74833L9.23791 7.88167C9.58708 8.09083 10.0354 8.0175 10.2996 7.70917L13.8337 3.58583V5.5C13.8337 5.96 14.2062 6.33333 14.6671 6.33333C15.1279 6.33333 15.5004 5.96 15.5004 5.5V1.33333C15.5004 1.3225 15.4946 1.31333 15.4937 1.3025Z",
    fill: "#03A66D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.e7d74a68ebc646bc491364c290e7a283.svg";
export { ForwardRef as ReactComponent };